__turbopack_context__.v({
  "actions": "kalshi-practice-board-module__FCsUIq__actions",
  "appHeader": "kalshi-practice-board-module__FCsUIq__appHeader",
  "best": "kalshi-practice-board-module__FCsUIq__best",
  "boardFooter": "kalshi-practice-board-module__FCsUIq__boardFooter",
  "caveat": "kalshi-practice-board-module__FCsUIq__caveat",
  "clearSlip": "kalshi-practice-board-module__FCsUIq__clearSlip",
  "clickLabel": "kalshi-practice-board-module__FCsUIq__clickLabel",
  "columns": "kalshi-practice-board-module__FCsUIq__columns",
  "desktopComparison": "kalshi-practice-board-module__FCsUIq__desktopComparison",
  "edge": "kalshi-practice-board-module__FCsUIq__edge",
  "empty": "kalshi-practice-board-module__FCsUIq__empty",
  "event": "kalshi-practice-board-module__FCsUIq__event",
  "expand": "kalshi-practice-board-module__FCsUIq__expand",
  "expanded": "kalshi-practice-board-module__FCsUIq__expanded",
  "filterHint": "kalshi-practice-board-module__FCsUIq__filterHint",
  "filterSection": "kalshi-practice-board-module__FCsUIq__filterSection",
  "guideControl": "kalshi-practice-board-module__FCsUIq__guideControl",
  "logo": "kalshi-practice-board-module__FCsUIq__logo",
  "market": "kalshi-practice-board-module__FCsUIq__market",
  "marketKind": "kalshi-practice-board-module__FCsUIq__marketKind",
  "mobileBook": "kalshi-practice-board-module__FCsUIq__mobileBook",
  "mobileComparison": "kalshi-practice-board-module__FCsUIq__mobileComparison",
  "mobileFair": "kalshi-practice-board-module__FCsUIq__mobileFair",
  "notice": "kalshi-practice-board-module__FCsUIq__notice",
  "priceView": "kalshi-practice-board-module__FCsUIq__priceView",
  "row": "kalshi-practice-board-module__FCsUIq__row",
  "rowHint": "kalshi-practice-board-module__FCsUIq__rowHint",
  "scope": "kalshi-practice-board-module__FCsUIq__scope",
  "scopeGroup": "kalshi-practice-board-module__FCsUIq__scopeGroup",
  "search": "kalshi-practice-board-module__FCsUIq__search",
  "selection": "kalshi-practice-board-module__FCsUIq__selection",
  "shell": "kalshi-practice-board-module__FCsUIq__shell",
  "slip": "kalshi-practice-board-module__FCsUIq__slip",
  "slipCard": "kalshi-practice-board-module__FCsUIq__slipCard",
  "sport": "kalshi-practice-board-module__FCsUIq__sport",
  "spotlight": "kalshi-practice-board-module__FCsUIq__spotlight",
  "table": "kalshi-practice-board-module__FCsUIq__table",
  "toolbar": "kalshi-practice-board-module__FCsUIq__toolbar",
  "verdict": "kalshi-practice-board-module__FCsUIq__verdict",
  "weightsButton": "kalshi-practice-board-module__FCsUIq__weightsButton",
  "whaleAside": "kalshi-practice-board-module__FCsUIq__whaleAside",
  "whaleDetail": "kalshi-practice-board-module__FCsUIq__whaleDetail",
  "whaleGrid": "kalshi-practice-board-module__FCsUIq__whaleGrid",
  "whaleIntro": "kalshi-practice-board-module__FCsUIq__whaleIntro",
  "whaleList": "kalshi-practice-board-module__FCsUIq__whaleList",
  "whaleListLabel": "kalshi-practice-board-module__FCsUIq__whaleListLabel",
  "whaleShell": "kalshi-practice-board-module__FCsUIq__whaleShell",
});
